import { Component, OnInit } from '@angular/core';
import {faPhoneAlt} from '@fortawesome/free-solid-svg-icons';
// import { faCl } from '@fortawesome/free-brands-svg-icons';
import {faClock} from '@fortawesome/free-regular-svg-icons';
import {StoreDetailsService} from '../../../services/store-details.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  public store: any;
  phoneIcon = faPhoneAlt;
  clockIcon = faClock;
  constructor(public storeDetails: StoreDetailsService) { }

  ngOnInit() {
    this.store = this.storeDetails.store;
  }
  ToggleNavBar() {
    const element: HTMLElement = document.getElementsByClassName( 'navbar-toggler' )[ 0 ] as HTMLElement;
    if ( element.getAttribute( 'aria-expanded' ) === 'true' ) {
      element.click();
    }
  }
}
